<template>
  <div class="dropzone" :class="{ dragging: isOver }"
       v-on:dragover="dragOverHandler($event)"
       v-on:dragend="dragEndHandler($event)"
       v-on:dragenter="dragEnterHandler($event)"
       v-on:dragleave="dragLeaveHandler($event)"
       v-on:dragexit="dragExitHandler($event)"
       v-on:dragstart="dragStartHandler($event)"
       v-on:drop="dropHandler($event)">
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  name: 'FileUploader',
  components: {},
  props: {},
  data() {
    return {
      isOver: false,
      isDrag: false,
    };
  },
  methods: {
    dragOverHandler(e) {
      this.isOver = this.isFileEvent(e);
      e.preventDefault();
    },
    dropHandler(e) {
      this.isOver = false;
      if (this.isFileEvent(e)) {
        this.$emit('drop', event);
      }
      e.preventDefault();
    },
    dragEndHandler(e) {
      this.isDrag = false;
      e.preventDefault();
    },
    dragExitHandler(e) {
      this.isOver = false;
      e.preventDefault();
    },
    dragStartHandler(e) {
      this.isOver = this.isFileEvent(e);
      e.preventDefault();
    },
    dragEnterHandler(e) {
      this.isOver = this.isFileEvent(e);
      e.preventDefault();
    },
    dragLeaveHandler(e) {
      this.isOver = false;
      e.preventDefault();
    },
    isFileEvent(e) {
      const transfer = (e.originalEvent || e).dataTransfer;
      transfer.dropEffect = 'copy';
      const isDrag = transfer.types && transfer.types[0] === 'Files';
      return isDrag;
    },
  },
  watch: {
  },
};
</script>

<style>
  .dropzone {
    padding: 10px;
    border: 1px #000 dotted;
  }
  .dragging {
    background-color: #cccccc;
  }

</style>



// WEBPACK FOOTER //
// src/components/DragDropWatcher.vue